import styled from 'styled-components';
import {
  feedbacksIbmplexsansNormalMountainMist16px,
  feedbacksIbmplexsansNormalShark20px,
  IbmplexsansNormalShark16px,
} from '../../../styledMixins';
import { DialogActions, DialogContent } from '@mui/material';

export const AwaitFeedbackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  align-self: stretch;
  gap: 25px;
  line-height: normal;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  align-self: stretch;
  gap: 25px;
  line-height: normal;

  @media screen and (max-width: 1024px) and (min-width: 766px) {
    width: 100%;
  }
  @media screen and (max-width: 765px) {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }
`;

export const Ellipse141 = styled.div`
  position: relative;
  min-width: 15px;
  height: 15px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 10px;
`;
export const Label = styled.div`
  position: relative;
  align-self: stretch;
  margin-top: -1px;
  display: flex;
  align-items: center;
  color: var(--text, #1e252a);
  font-style: normal;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 500;
  letter-spacing: 0;
  line-height: 26px;
`;

export const OptionContainer = styled.button`
  min-width: 112px;
  min-height: 33px;
  border-radius: 22px;
  border: 1px solid rgba(201, 198, 204, 0.5);
  padding: 8px;
  display: flex;
  align-items: center;
  text-align: start;
  gap: 8px;
  background-color: white;
  cursor: pointer;

  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: var(--font-size-s);
  line-height: 16px;
  color: #7b7382;

  &:hover {
    background-color: rgba(201, 198, 204, 0.5);
  }
`;

export const TitleWrapper = styled.div`
  width: 880px;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  margin-top: -1px;
  letter-spacing: -0.9px;
  line-height: normal;
  gap: 10px;
`;

export const ButtonContainer = styled.div`
  width: 30%;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  width: 100%;
  background-color: var(--white);
  box-shadow: 0px 3px 12px 0px rgba(48, 27, 114, 0.06);
  padding: 16px 30px;
  border-radius: 8px;
  min-height: 66px;
`;

export const EditTextBox = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: var(--font-size-l);
  letter-spacing: 0px;
  line-height: 20px;
  color: #7a7a7a;
  width: fit-content;
`;

export const FeedbackBtnContainer = styled.div`
  /* display: flex;
  flex-direction: column;
  gap: 15px; */
  width: 30%;
`;

export const StatusText = styled.div`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;

  letter-spacing: -0.025em;

  color: #979797;
  display: flex;
  align-items: center;
  gap: 4px;

  @media screen and (max-width: 765px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Screen = styled.div`
  position: fixed;
  width: 200vw;
  height: 200vh;
  top: 0;
  left: 0;
  z-index: 0;
`;
export const Screen2 = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 1);
  z-index: 1;
`;
export const Line6 = styled.img`
  position: relative;
  align-self: stretch;
  width: 100%;
  height: 1px;
  object-fit: cover;
`;

export const Frame131612 = styled.div`
  max-width: 300px;
  display: flex;
`;
// Teacher Loop: on the Teacher Check page its bar sits between the header and
// this container, so the container gives up the bar's height
// (teacherCheckBarHeight, set on that page only; without it the height is the
// usual calc(100dvh - 70px)).
export const PageContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    prop !== 'contentOffset' && prop !== 'teacherCheckBarHeight',
})`
  display: flex;
  /* Keep the student/question controls inside the viewport. Only the response
     and side panels scroll; a second page scroll hides the controls on return. */
  height: ${(props) =>
    props.teacherCheckBarHeight > 0
      ? `calc(100dvh - 70px - ${props.teacherCheckBarHeight}px)`
      : 'calc(100dvh - 70px)'};
  padding-bottom: 48px;
  box-sizing: border-box;
  overflow: hidden;
  ::-webkit-scrollbar {
    width: 0;
  }
  background: #faf7fc;
  position: relative;
  margin-left: ${(props) => `${props.contentOffset ?? 0}px`};
  width: ${(props) => `calc(100% - ${props.contentOffset ?? 0}px)`};
`;

export const Main = styled.div`
  width: ${(props) => (props.open ? props.drawerWidth + 'px' : '0')};
  margin-left: ${(props) => (props.open ? '35px' : '0')};
  transform: translateX(
    ${(props) => (props.open ? '0' : `-${props.drawerWidth}px`)}
  );
  transition: transform 0.3s ease-in;
  height: 100vh;
  overflow-y: auto;
  position: fixed;
  top: 70px;
  left: 0;
  background-color: #f0f0f0;
`;

export const Main2 = styled.div`
  width: 300px;
  height: 100vh;
  overflow-y: auto;
  position: fixed;
  top: 70px;
  left: 0;
  background-color: #f0f0f0;
`;

export const Frame1388 = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'contentOffset',
})`
  flex: 1;
  width: ${(props) =>
    props.contentOffset != null
      ? `calc(100vw - ${props.contentOffset}px)`
      : '100vw'};
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  gap: 30px;
  align-self: stretch;
  transition: transform 0.3s ease-in;
  height: ${(props) => (props.mobileView ? '0px' : 'auto')};
  min-height: 0;
  overflow: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  background: #faf7fc;

  /* @media (min-width: 1600px) {
    max-width: 1300px;
  }  */
`;

export const CountZoomContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'sidebarOffset',
})`
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  display: ${(props) => (props.mobileView ? 'none' : '')};
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: var(--font-size-l);
  line-height: 24px;
  color: #000000;
  transition: transform 0.3s ease-in, width 0.3s ease-in;
  background-color: var(--white);
  padding: 12px 30px;
  left: ${(props) => `${props.sidebarOffset ?? 80}px`};
  width: ${(props) =>
    props.sidebarOffset != null
      ? `calc(100% - ${props.sidebarOffset}px)`
      : 'calc(100% - 80px)'};
  box-shadow: 0 -3px 12px 0 rgba(48, 27, 114, 0.06);
  z-index: 2;
`;

export const ZoomContianer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: var(--font-size-l);
  line-height: 24px;
  color: #000000;
`;

export const ZoomInput = styled.input`
  -webkit-appearance: none;
  -moz-apperance: none;
  appearance: none;
  width: 183px;
  height: 2px;
  border-radius: 5px;
  cursor: pointer;
  background-color: transparent;

  &::-webkit-slider-runnable-track {
    background-color: #8f8f8f;
    border-radius: 5px;
    height: 1px;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--light-mode-purple);
    cursor: pointer;
    margin-top: -10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
`;

export const Frame1387 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  position: relative;
  align-self: stretch;
`;
export const Frame1315 = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 0px 0px 0px 60px;
  position: relative;
  align-self: stretch;
`;
export const Frame1386 = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
`;

export const Frame1371 = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 32px;
  z-index: 2;
  background-color: #faf7fc;
  width: 100%;

  @media screen and (max-width: 1024px) and (min-width: 766px) {
    gap: 40px;
  }
  @media screen and (max-width: 765px) {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    flex-wrap: wrap;
  }
`;

export const AssignmentTitle = styled.h1`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-weight: 400;
  line-height: 26px;
  font-style: normal;
  position: relative;
  color: var(--text);
  flex: 1;
  margin-top: -1px;
`;

export const QuestionEditInput = styled.textarea`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  color: var(--text);
  font-weight: 400;
  line-height: 26px;
  font-style: normal;
  border: none;
  outline: none;
  resize: none;
  width: 100%;
`;

export const Crown = styled.img`
  position: relative;
  min-width: 20px;
  height: 20px;
`;

export const FeedbackBody = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
`;

/* The answer editor's side margins (80px in QuillEditor/styles.css) tapered
   with its width: still 80px on the 650px page, down to 20px once the page
   narrows to fit beside the comment gutter (see Group1225). Percentages
   resolve against .ql-container, the editor's (and its placeholder's)
   containing block. */
const EDITOR_SIDE_PADDING = 'clamp(20px, calc((100% - 320px) / 4), 80px)';

const frame1368TopGap = (props) => (props.$draftAuthoring ? '6px' : '24px');

export const Frame1368 = styled.div`
  /* Horizontal scroll container for the page + comments "spread". The spread
     (Group1225) is centered inside here via auto margins; when it is wider than
     the available space (small screens, or an open side panel) this element
     shows a horizontal scrollbar so every comment stays reachable.
     In upload mode, uses flex layout with centered alignment. */
  display: ${(props) => (props.$uploadMode ? 'flex' : 'block')};
  flex-direction: ${(props) => (props.$uploadMode ? 'column' : 'initial')};
  align-items: ${(props) => (props.$uploadMode ? 'center' : 'initial')};
  gap: ${(props) => (props.$uploadMode ? '32px' : 'initial')};
  align-self: stretch;
  position: relative;
  isolation: isolate;
  height: 100%;
  /* JED-1402: the top gap is a spacer block, not padding-top. A sticky child
     pins to the scroll container's padding edge, so padding left a strip of
     scrolled text visible above the sticky Quill toolbar. The ::before block
     keeps the resting layout identical and lets the toolbar pin flush to the
     top. Upload mode is a flex column with a 32px gap, where a pseudo-element
     would become a flex item and add a gap, so it keeps the padding. */
  padding-top: ${(props) => (props.$uploadMode ? frame1368TopGap(props) : '0')};
  padding-bottom: 24px;
  &::before {
    content: ${(props) => (props.$uploadMode ? 'none' : "''")};
    display: block;
    height: ${frame1368TopGap};
  }
  overflow-x: auto;
  overflow-y: scroll;
  width: 100%;
  box-sizing: border-box;
  background: ${(props) =>
    props.$uploadMode ? 'rgba(242, 241, 243, 0.65)' : 'transparent'};

  /* Reserve room on the right for the always-present 48px tab rail, and for the
     460/290px sliding panel when one is open, so the centered spread clears
     them and can be scrolled fully out from underneath them. */
  padding-left: ${(props) => (props.$uploadMode ? '0' : '16px')};
  padding-right: ${(props) => (props.$uploadMode ? '0' : '56px')};
  transition: padding-right 0.3s ease-in;

  @media (min-width: 766px) and (max-width: 1024px) {
    padding-right: ${(props) => {
      if (props.$uploadMode) return '0';
      return props.$panelOpen ? '338px' : '56px';
    }};
  }
  @media (min-width: 1025px) {
    padding-right: ${(props) => {
      if (props.$uploadMode) return '0';
      return props.$panelOpen ? '508px' : '56px';
    }};
  }

  @media (min-width: 766px) and (max-width: 1300px) {
    .quill-editor-container .ql-editor {
      padding-left: ${EDITOR_SIDE_PADDING} !important;
      padding-right: ${EDITOR_SIDE_PADDING} !important;
    }
    .quill-editor-container .ql-editor::before {
      padding: 0 calc(${EDITOR_SIDE_PADDING} - 15px) !important;
    }
  }

  /* Hide BOTH native scrollbars. The vertical one stays hidden as before; the
     horizontal one is hidden because macOS overlay-hides it until you actively
     scroll, so teachers who can't two-finger scroll never see it. The
     always-visible custom <HorizontalScrollbar> is the affordance instead.
     overflow-x stays auto above so trackpad/wheel scrolling still works. */
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;
/* The spread is the 650px page plus a 360px gutter on whichever sides currently
   hold anchored feedback: acknowledgements hang 340px to the LEFT of the page
   (AcknowledgementBox left:-340), comments/composer/instructions hang 340px to
   the RIGHT (CommentBox right:-340). Only occupied gutters count toward the
   centered width — an empty gutter would bias the page off-center (JED-1303) —
   and an occupied left gutter must be inside the spread, not overhanging it,
   because a scroll container can never scroll left of zero (JED-1305).
   When a generated-question stimulus sidebar is open, reserve Figma's 328px
   panel (+20px gap) beside the 650px page so Q/R keep their full page width. */
const PAGE_WIDTH = 650;
const GUTTER_WIDTH = 360;
const STIMULUS_WIDTH = 328;
const STIMULUS_GAP = 20;
const STIMULUS_SLOT = STIMULUS_WIDTH + STIMULUS_GAP;
const spreadWidth = (props) =>
  PAGE_WIDTH +
  (props.$stimulusSidebar ? STIMULUS_SLOT : 0) +
  (props.$leftGutter ? GUTTER_WIDTH : 0) +
  (props.$rightGutter ? GUTTER_WIDTH : 0);

/* From 766px to 1300px the spread is sized from the scroll area it sits in
   (Frame1368's content box, which already excludes the nav rail, the right tab
   rail and any open side panel), never from the viewport. Inside an LMS iframe
   (Canvas frames the app at ~800–1100px) and on narrow windows, 100vw-based
   widths ran the page under the tab rail and pushed the comment gutter out of
   view. The page takes whatever its occupied gutters leave, down to
   PAGE_MIN_WIDTH. Below that the spread itself grows past the scroll area, so
   the overflow is in-flow: the custom horizontal scrollbar reaches the right
   gutter clear of the tab rail, and the left gutter stays inside the spread so
   acknowledgements remain reachable (JED-1305). */
const PAGE_MIN_WIDTH = 280;
const occupiedGutters = (props) =>
  (props.$leftGutter ? GUTTER_WIDTH : 0) +
  (props.$rightGutter ? GUTTER_WIDTH : 0);
const minimumSpreadWidth = (props) => PAGE_MIN_WIDTH + occupiedGutters(props);

export const Group1225 = styled.div`
  /* The page and its occupied comment gutters as a single centered "spread".
     Auto margins center whatever combination is present (page alone, page +
     comments, acknowledgements + page + comments); anything that overflows is
     reachable through the custom horizontal scrollbar. */
  position: relative;
  display: block;
  min-height: 650px;
  width: 100%;

  @media (min-width: 766px) {
    width: ${(props) => spreadWidth(props)}px;
    margin: 0 auto;
    transition: width 0.3s ease-in;
  }

  @media (max-width: 1300px) and (min-width: 1001px) {
    width: max(
      min(${(props) => spreadWidth(props)}px, 100%),
      ${(props) => minimumSpreadWidth(props)}px
    );
    max-width: none;
  }

  @media (max-width: 1000px) and (min-width: 766px) {
    width: max(100%, ${(props) => minimumSpreadWidth(props)}px);
    max-width: none;
  }

  @media (max-width: 765px) {
    width: calc(100vw - 40px);
    max-width: calc(100vw - 40px);
  }
  ${(props) => props.$draftAuthoring && !props.$leftGutter && !props.$rightGutter && `
    && {
      width: ${props.$stimulusSidebar ? PAGE_WIDTH + STIMULUS_SLOT : PAGE_WIDTH}px;
      max-width: ${props.$stimulusSidebar ? '100%' : 'calc(100% - 40px)'};
      margin-inline: auto;
      left: ${props.$stimulusSidebar ? '0' : '20px'};
    }
  `}
`;
export const Frame1367 = styled.div`
  /* The document page. Horizontal centering is owned by Group1225; when the
     left gutter is occupied the page shifts right by the gutter width so the
     acknowledgements (absolutely positioned off the page's left edge) stay
     inside the spread — and therefore inside the scrollable area. */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  height: 100%;
  width: ${(props) =>
    props.$stimulusSidebar ? `${PAGE_WIDTH + STIMULUS_SLOT}px` : `${PAGE_WIDTH}px`};
  margin: 20px 0;
  margin-left: ${(props) => (props.$leftGutter ? `${GUTTER_WIDTH}px` : '0')};
  transition: margin-left 0.3s ease-in, width 0.3s ease-in;
  border-radius: 10px;

  @media (max-width: 1300px) and (min-width: 766px) {
    width: calc(100% - ${(props) => occupiedGutters(props)}px);
    max-width: 100%;
  }

  @media (max-width: 765px) {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
  }
  ${(props) => props.$draftAuthoring && `
    width: 100%;
    margin-top: ${props.$questionStage === 'setup' ? 0 : ['preview', 'update'].includes(props.$questionStage) ? 44 : 16}px;
  `}
`;

export const AddCommentFocusAreaDiv = styled.div`
  /* "How to comment" hint, shown only before any comment exists. Sits in the
     comment gutter just to the right of the 650px page, inside the spread, so it
     travels with the page+comments unit when it is centered or scrolled. When
     the left gutter is occupied the page sits 360px further right; follow it. */
  position: absolute;
  top: 0;
  left: ${(props) => (props.$leftGutter ? '1020px' : '660px')};
  width: 314px;
  z-index: -10;

  /* Narrower spreads fit the page to the space beside its gutters (see
     Group1225), so the page ends one gutter short of the spread's right edge;
     the hint is only rendered with the right gutter reserved. */
  @media (max-width: 1300px) and (min-width: 766px) {
    left: calc(100% - ${GUTTER_WIDTH - 10}px);
  }
`;

export const Frame1366 = styled.div`
  display: ${(props) => (props.$stimulusSidebar ? 'grid' : 'flex')};
  ${(props) =>
    props.$stimulusSidebar
      ? `
    grid-template-columns: ${PAGE_WIDTH}px ${STIMULUS_WIDTH}px;
    gap: ${STIMULUS_GAP}px;
    align-items: start;
    width: ${PAGE_WIDTH + STIMULUS_SLOT}px;
  `
      : `
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
  `}
  position: relative;
  align-self: stretch;
  min-height: 0;

  @media (max-width: 1300px) and (min-width: 1001px) {
    ${(props) =>
      props.$stimulusSidebar &&
      `
      grid-template-columns: 1fr ${STIMULUS_WIDTH}px;
      width: 100%;
      max-width: 100%;
      gap: 16px;
    `}
  }

  @media (max-width: 1000px) {
    ${(props) =>
      props.$stimulusSidebar &&
      `
      grid-template-columns: 1fr;
      width: 100%;
    `}
  }
`;

export const GeneratedMainColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  min-width: 0;
  width: 100%;
  ${(props) =>
    props.$withSidebar &&
    `
    grid-column: 1;
    grid-row: 1;
    width: ${PAGE_WIDTH}px;
    max-width: ${PAGE_WIDTH}px;
  `}

  @media (max-width: 1300px) and (min-width: 1001px) {
    ${(props) =>
      props.$withSidebar &&
      `
      width: 100%;
      max-width: 100%;
      min-width: 0;
    `}
  }
  @media (max-width: 1000px) { width: 100%; max-width: 100%; }
`;

export const MarkingCriteriaAndCommentBankContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const QuestionContainer = styled.div`
  background-color: ${(props) => (props.$bare ? 'transparent' : 'var(--white)')};
  border-radius: ${(props) => (props.$bare ? '0' : '8px')};
  border: ${(props) =>
    props.$bare
      ? 'none'
      : props.$showAIForm
      ? '2px solid #7200e0'
      : '1px solid rgba(178, 174, 183, 0.5)'};
  box-shadow: ${(props) =>
    props.$bare ? 'none' : '0px 4px 9px 0px rgba(133, 133, 133, 0.25)'};
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: ${(props) => (props.$bare ? 'visible' : 'hidden')};
`;

export const QuestionMascot = styled.img`
  position: absolute;
  right: 24px;
  bottom: 16px;
  width: 143px;
  height: 169px;
  object-fit: contain;
  pointer-events: none;
  z-index: 1;
`;

export const QuestionTitleBox = styled.div`
  background: var(--color-purple-80, #f1e6fc);
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  line-height: 24px;
  color: rgba(40, 31, 69, 1);
  padding: 8px 20px;
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  position: relative;
  z-index: 10;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
    background-color: transparent;
    border: none;
    font-family: var(--font-family-ibm_plex_sans);
    font-weight: 600;
    line-height: 24px;
    cursor: pointer;
  }
  &.response-header-row {
    gap: 0;
  }
  /* The generic button reset above would leave Resubmit transparent; repaint the
     enabled pill only, so its disabled grey still shows. */
  .response-resubmit-btn-wrap button:not(:disabled) {
    background: #7200e0;
  }
  .response-submit-btn-wrap button {
    pointer-events: none;
    gap: 0 !important;
    background: #7200e0 !important;
    align-items: stretch !important;
    min-height: 40px;
    height: 40px;
  }

  @media screen and (max-width: 765px) {
    padding: 8px 12px;
    gap: 8px;
  }
`;

export const Line = styled.img`
  width: 100%;
  margin-top: 50px;
`;

export const AnswerContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(201, 198, 204, 0.5);
  box-shadow: 0px 4px 9px 0px rgba(133, 133, 133, 0.25);
  border-radius: 8px;
  opacity: ${(props) => props.$disabled ? .4 : 1};
  pointer-events: ${(props) => props.$disabled ? 'none' : 'auto'};
`;

export const QuestionText = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  line-height: ${(props) => (props.$compact ? '24px' : '24px')};
  color: #181718;
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  display: ${(props) => (props.slide ? 'auto' : 'none')};
  padding: ${(props) => (props.$compact ? '0' : '20px 80px')};
  overflow: hidden;
`;

export const QuestionInputBox = styled.textarea`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 16px;
  color: rgba(24, 23, 24, 1);
  font-weight: 400;
  line-height: 24px;
  border: none;
  outline: none;
  resize: none;
  width: 100%;
  padding: 20px 80px;
  display: ${(props) => (props.slide ? 'auto' : 'none')};
  overflow: hidden;
`;

export const QuestionActions = styled.div`
  display: ${(props) => (props.slide ? 'flex' : 'none')};
  flex-direction: column;
  width: 100%;
  padding: 0;
`;

export const QuestionActionsBody = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 0 80px 20px;
`;

export const QuestionActionsFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 20px;
  border-top: 1px solid rgba(201, 198, 204, 0.5);
`;

export const StimulusActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: ${(props) => (props.$footer ? '8px 12px 8px 8px' : '4px 8px 4px 5px')};
  border-radius: ${(props) => (props.$footer ? '8px' : '21px')};
  border: 1px solid #7200e0;
  background: ${(props) => (props.$footer ? '#fbf7fe' : '#fff')};
  color: #7200e0;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: ${(props) => (props.$footer ? '14px' : '16px')};
  font-weight: ${(props) => (props.$footer ? '400' : '600')};
  line-height: 24px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    background: ${(props) => (props.$footer ? '#f1e6fc' : '#fbf7fe')};
  }
`;

export const StimulusActionIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
`;

export const StimulusPreviewList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
`;

export const StimulusPreviewChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1.5px solid #dec7ff;
  background: #f6efff;
  max-width: 170px;
  cursor: pointer;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const StimulusPreviewIconWrap = styled.span`
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 1px solid #dec7ff;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StimulusPreviewIcon = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
`;

export const StimulusPreviewImage = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 1px solid #dec7ff;
  object-fit: cover;
  flex-shrink: 0;
  display: block;
`;

export const StimulusPreviewLabel = styled.span`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  font-weight: 500;
  color: #4b464f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
`;

export const QuillContainer = styled.div`
  ${feedbacksIbmplexsansNormalShark20px}
  position: relative;
  align-self: stretch;
  letter-spacing: 0;
  line-height: normal;
  width: 100%;
  height: 100%;
  min-height: 200px;
  z-index: 1;
  display: flex;
  cursor: text;
  pointer-events: auto;
`;

export const Frame1331 = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  align-items: flex-start;
  gap: 20px;
  padding: 20px 20px;

  position: sticky;
  top: 0px;
  //background-color: var(--white);
  border-radius: 16px;
  height: calc(100vh - 130px);
  overflow-y: scroll;
  //box-shadow: 0px 4px 22px #2f1a720a;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const Frame1322 = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  position: relative;
  align-self: stretch;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const Frame1329 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
  position: relative;
  align-self: stretch;
`;
export const Frame1406 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  position: relative;
  align-self: stretch;
`;
export const Frame1326 = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  align-self: stretch;
  background-color: var(--white);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid;
  border-color: var(--text);
  height: 46px;
`;
export const TypeHere = styled.div`
  ${feedbacksIbmplexsansNormalMountainMist16px}
  position: relative;
  flex: 1;
  letter-spacing: 0;
`;

export const Frame1383 = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  align-self: stretch;
  padding: 20px;
`;
export const Frame13311 = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
  align-self: stretch;
  margin: 10px 0 5px;
`;
export const Share = styled.div`
  color: var(--black);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 400;
  position: relative;
  width: fit-content;
  margin-top: -1px;
  letter-spacing: 0;
  line-height: 20px;
`;

export const Frame1328 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 0px 0px 30px;
  position: relative;
  flex: 1;
  align-self: stretch;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SelectFeedbackMethod = styled.div`
  display: flex;
  width: fit-content;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(114, 0, 224, 0.1);
  position: absolute;
  white-space: nowrap;
  top: 42px;
  right: 0px;
`;

export const SelectFeedbackMethodType = styled.div`
  display: block;
  width: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 2px;
  padding: 10px 12px;
  border-radius: 10px;
  text-align: left;
  ${IbmplexsansNormalShark16px};

  &:hover {
    background-color: var(--blue-chalk);
  }
`;

export const Icon24 = styled.img``;

export const ButtonWithImageBeforeText = styled.button`
  background-color: var(--light-mode-purple);
  color: var(--white);
  border-radius: 24px;
  padding: 8px 16px;
  border: 1px solid var(--light-mode-purple);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const RequestFeedbackStatusFrame = styled.div`
  cursor: pointer;
  display: flex;
  padding: 20px 16px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  color: white;
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 100%;
  background-color: var(--white) !important;

  gap: 5px;
  align-items: center;
  background-color: var(--white);
  box-shadow: 0px 3px 12px 0px rgba(48, 27, 114, 0.06);
  padding: 20px 30px;
  border-radius: 8px;
`;

export const RequestFeedbackFrame = styled.div`
  cursor: pointer;
  display: flex;
  padding: 20px 16px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  color: white;
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 12px;
  width: 100%;
  background-color: var(--white) !important;
`;

export const RequestFeedbackButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 20px 16px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  color: white;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 12px;
  width: 100%;
  background-color: var(--light-mode-purple) !important;
  height: 66px;
`;
export const RequestFeedbackDropdown = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconContainer = styled.img`
  position: relative;
  min-width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 20px;
`;

export const DropdownButtonsGroup = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  box-shadow: 0px 4px 8px #2f1a720a;
  background-color: var(--white);
  border-radius: 8px;
  border: 1px solid #2f1a720a;
  padding: 10px;
`;

export const DropdownButton = styled.button`
  display: block;
  width: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 2px;
  padding: 10px 12px;
  border-radius: 10px;
  text-align: left;
  ${IbmplexsansNormalShark16px};

  &:hover {
    background-color: var(--blue-chalk);
  }
`;

export const ExemplarComponent = styled.div`
  width: 100%;
  position: relative;
  bottom: 0;
`;

export const SmartAnnotationsComponent = styled.div`
  width: 100%;
  height: 330px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: scroll;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const ShortcutList = styled.div`
  height: 210px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  border-radius: 12px;
  gap: 30px;
  padding: 0px 0px 30px 0px;
`;
export const Frame1334 = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  border-radius: 12px 12px 0px 0px;
  gap: 10px;
  background: #f7eeff;
`;
export const Frame1334Img = styled.img`
  width: 24px;
  height: 24px;
`;

export const Frame1577 = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 85%;
`;
export const Frame1577heading = styled.p`
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #1e252a;
`;

export const Frame1577Img = styled.img`
  width: 24px;
  height: 24px;
  padding: 2px 2px 2px 2px;
`;

export const Frame5053 = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 30px 0px 30px;
  gap: 20px;
`;
export const Frame5053Card1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 30px;
  border-radius: 8px;
  border: 1px;
  gap: 16px;
  border: 1px solid #f1e7ff;
  cursor: pointer;
  background-color: #f5effe;
  :hover {
    background: linear-gradient(0deg, #f1e7ff, #f1e7ff),
      linear-gradient(0deg, #f5effe, #f5effe);
    border: 1px solid #7200e0;
  }
`;

export const Frame5053Card1Img = styled.img`
  width: 36px;
  height: 36px;
`;
export const Card1ImgContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const Card1Img = styled.img`
  width: 21px;
  height: 24px;
  padding: 3px 6px 3px 6px;
  gap: 10px;
`;
export const Frame5053Card1Para = styled.div`
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
`;
export const Frame5053Card2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  border-radius: 8px;
  border: 1px;
  gap: 16px;
  border: 1px solid #f1e7ff;
  cursor: pointer;
  background-color: #f5effe;
  :hover {
    background: linear-gradient(0deg, #f1e7ff, #f1e7ff),
      linear-gradient(0deg, #f5effe, #f5effe);
    border: 1px solid #7200e0;
  }
`;
export const Frame5053Card2Data = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

export const Frame1364 = styled.div`
  padding: 0px 30px 30px 30px;
  gap: 10px;
`;
export const Frame1364Button = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 16px 12px 16px;
  border-radius: 30px;
  gap: 4px;
  background: #a6a6a6;
  color: #fff;
  cursor: pointer;
  :hover {
    background: #7200e0;
  }
`;
export const Frame1364ButtonText = styled.div`
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
`;
export const PoupButtons = styled(DialogActions)`
  gap: 10px;
`;
export const PoupDialogContent = styled(DialogContent)`
  padding: 20px 24px 0px 24px !important;
`;
